/* Wrist Theory — interacciones. Vanilla JS, sin librerias.
   Un IntersectionObserver compartido para las entradas al scroll. */
(function () {
  'use strict';
  if (window.__wtInit) return;
  window.__wtInit = true;

  function initReveals() {
    var els = document.querySelectorAll('.wt-reveal');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('wt-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wt-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  function initPopup() {
    var p = document.getElementById('wt-popup');
    if (!p) return;

    // No molestar en carrito/checkout ni si ya se vio en esta visita
    if (/\/(cart|checkout|account)/.test(window.location.pathname)) return;
    try { if (sessionStorage.getItem('wtPopupSeen')) return; } catch (e) {}

    var delay = (parseInt(p.getAttribute('data-delay'), 10) || 25) * 1000;
    var shown = false, timer = null;

    function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }
    function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) open(); }

    function open() {
      if (shown) return;
      shown = true;
      clearTimeout(timer);
      document.removeEventListener('mouseout', onExit);
      p.classList.add('wt-popup--open');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var c = p.querySelector('.wt-popup__close');
      if (c) { try { c.focus(); } catch (e) {} }
      try { sessionStorage.setItem('wtPopupSeen', '1'); } catch (e) {}
    }

    function close() {
      p.classList.remove('wt-popup--open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }

    Array.prototype.forEach.call(p.querySelectorAll('[data-wt-popup-close]'), function (b) {
      b.addEventListener('click', close);
    });

    timer = setTimeout(open, delay);
    document.addEventListener('mouseout', onExit);
  }

  // Producto digital: siempre exactamente 1 en el carrito.
  // Al comprar: vaciar -> añadir 1 -> ir al checkout. (Tienda de un solo producto.)
  function initBuyNow() {
    var forms = document.querySelectorAll('.wt-buyform');
    if (!forms.length) return;
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value || !window.fetch) return; // fallback: envío normal
        e.preventDefault();
        var vid = idInput.value;
        var btn = form.querySelector('button');
        if (btn) btn.disabled = true;
        // Recoge las propiedades de línea (name="properties[...]") para mostrarlas en el checkout
        var props = {};
        Array.prototype.forEach.call(form.querySelectorAll('input[name^="properties["]'), function (inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (m && inp.value) props[m[1]] = inp.value;
        });
        var addBody = { id: vid, quantity: 1 };
        if (Object.keys(props).length) addBody.properties = props;
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addBody)
            });
          })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { if (btn) btn.disabled = false; form.submit(); });
      });
    });
  }

  // En la página /cart, limita la cantidad a 1 (digital).
  function initCartQty() {
    var form = document.querySelector('.wt-cart__form');
    var inputs = document.querySelectorAll('.wt-cart__qty input[name="updates[]"]');
    if (!inputs.length) return;
    var changed = false;
    function clamp(input) {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v > 1) { input.value = 1; return true; }
      if (v < 0) { input.value = 0; }
      return false;
    }
    Array.prototype.forEach.call(inputs, function (input) {
      if (clamp(input)) changed = true; // cantidad vieja (>1)
      input.addEventListener('change', function () { clamp(input); });
    });
    // Si venía un carrito con >1 (digital), corrígelo de verdad en el servidor y recarga
    if (changed && form) { form.submit(); }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    initReveals();
    initPopup();
    initBuyNow();
    initCartQty();
  });
})();
